import { defineStore } from "pinia";
import { IOptionsUser } from "@/schemas/user/userSchema";

interface State {
  currentUser: IOptionsUser;
  teamUsers?: IOptionsUser[];
}

export const useUserStore = defineStore("userStore", {
  state: (): State => ({
    currentUser: {
      userId: "",
      name: "",
      profilePhotoUrl: "",
    },
  }),

  actions: {
    setCurrentUser(val: IOptionsUser) {
      this.currentUser = val;
    },
    setTeamUsers(val: IOptionsUser[]) {
      this.teamUsers = val.filter(
        (user) =>
          user.userId !== this.currentUser.userId && user.userId !== undefined
      );
    },
  },
});
